import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["input", "tab"];

  initialize() {
    this._boundKeydownHandler = (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        event.currentTarget.click();
      } else if (['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
        this._handleArrowNavigation(event);
      }
    };
  }

  tabTargetConnected(tab) {
    tab.addEventListener('keydown', this._boundKeydownHandler);
  }

  tabTargetDisconnected(tab) {
    tab.removeEventListener('keydown', this._boundKeydownHandler);
  }

  select(event) {
    if (event.currentTarget.classList.contains("disabled")) {
      return false;
    }


    let target = event.target;

    if (target.nodeName !== 'LI') {
      target = target.closest('li');
    }

    this._updateFormFieldValues(target);
    this._removeBackgrounds();
    this._setBackground(target);
  }

  _handleArrowNavigation(event) {
    const navigableTabs = this.tabTargets.filter(tab =>
      !tab.classList.contains('disabled')
    );
    const currentIndex = navigableTabs.indexOf(event.currentTarget);
    if (currentIndex === -1) return;

    let nextIndex;
    switch (event.key) {
      case 'ArrowRight': nextIndex = (currentIndex + 1) % navigableTabs.length; break;
      case 'ArrowLeft':  nextIndex = (currentIndex - 1 + navigableTabs.length) % navigableTabs.length; break;
      case 'Home':       nextIndex = 0; break;
      case 'End':        nextIndex = navigableTabs.length - 1; break;
      default: return;
    }

    event.preventDefault();
    navigableTabs[nextIndex].focus();
  }

  _updateFormFieldValues(target) {
    let formName = this.inputTarget.name.split('[')[0];
    const formFieldName = target.dataset.filterName;
    const formFieldValue = target.dataset.filterValue;

    let formFields = document.querySelectorAll(`[name="${formName}[${formFieldName}]"]`);

    formFields.forEach(field => {
      field.value = formFieldValue;
    })
  }

  _removeBackgrounds() {
    this.tabTargets.forEach(tab => {
      tab.classList.remove('active');
    })
  }

  _setBackground(target) {
    target.classList.add('active');
  }
}
